import http from "../../http";
import request from "../../request";
import { getToken } from "@/utils/auth";

/** 房屋档案 — /resident/api/resident/house */
const BASE = "/resident/api/resident/house";

function resolveDownloadFilename(disposition, fallback) {
  if (!disposition) return fallback;
  const utf8 = /filename\*=utf-8''([^;]+)/i.exec(disposition);
  if (utf8 && utf8[1]) {
    try {
      return decodeURIComponent(utf8[1]);
    } catch (e) {
      return utf8[1];
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  return (plain && plain[1]) || fallback;
}

const house = {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  /** 透视图：按小区层级展开（含人员摘要） */
  selectPerspective(r) {
    return http.get(`${BASE}/perspective`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
  /** 轻量修改共治状态 */
  updateJoinStatus(r) {
    return http.tip.post(`${BASE}/updateJoinStatus`, r);
  },
  delete(r) {
    return http.confirm.post(`${BASE}/delete`, r);
  },
  /** 下载导入模版（按地址规则动态表头，含小区/规则标注） */
  async downloadImportTemplate(ruleId) {
    const res = await request({
      url: `${BASE}/importTemplate`,
      method: "get",
      params: { ruleId },
      responseType: "blob",
      headers: getToken() ? { Authorization: getToken() } : {},
    });
    const blob = res && res.data;
    if (!blob) throw new Error("模版下载失败");
    if (blob.type && blob.type.indexOf("application/json") >= 0) {
      const text = await blob.text();
      let desc = "模版下载失败";
      try {
        const json = JSON.parse(text);
        if (json && json.desc) desc = json.desc;
      } catch (e) {
        /* ignore */
      }
      throw new Error(desc);
    }
    const filename = resolveDownloadFilename(
      res.headers && (res.headers["content-disposition"] || res.headers["Content-Disposition"]),
      "房屋导入模版.xlsx"
    );
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  },
  /** 导入预览校验（不落库） */
  importPreview(formData) {
    return http.spin.postFile(`${BASE}/importPreview`, formData);
  },
  /** 确认导入（仅导入校验通过行） */
  importHouses(formData) {
    return http.spin.postFile(`${BASE}/import`, formData);
  },
};

export default house;
